import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'do_wrkrs_have_the_right_to_respond_to_andor_appeal_any_discipli'

export const dataPointDefinition = {
  retracedId: 'do_wrkrs_have_the_right_to_respond_to_andor_appeal_any_discipli',
  name: 'Do workers have the right to respond to and/or appeal any disciplinary decisions without any negative repercussions?',
  description:
    'In the event a disciplinary action is taken, the intent of this question is to understand if workers have the right to response and/or appeal the action (or decision) without bring any negative repercussions to them. \r\r\n\r\r\nFor example, if a worker appeals the disciplinary action taken by a line-supervisor to the (more senior) Production Manager and the appeal results in the worker being demoted, answer No.',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'discp-4',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 11580,
  sectionId: '2.2.4.4',
  impactArea: 'Discipline',
  impactAreaId: 'DISCIPLINE',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
